import { action, get, set } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import logger from 'donor-elf-web/lib/logger';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import RSVP from 'rsvp';

const demoValidation = {
  // nothing yet
};

export default Route.extend({
  cookies: service(),
  currentUser: service(),
  navbarSettings: service(),
  router: service(),
  session: service(),
  store: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'Demo Login');
  },

  model() {
    let logoutPromise = RSVP.resolve();
    let session = this.session;
    if (get(session, 'isAuthenticated')) {
      logoutPromise = session.invalidate();
    }

    return logoutPromise.then(() => {
      let model = this.store.createRecord('demo-viewer', {
        roleId: 1,
      });
      return {
        changeset: new Changeset(
          model,
          lookupValidator(demoValidation),
          demoValidation,
        ),
      };
    });
  },

  afterModel(model) {
    let previousDemoEmail = this.cookies.read('demo_email');
    if (!isEmpty(previousDemoEmail)) {
      let changeset = get(model, 'changeset');
      set(changeset, 'email', previousDemoEmail);
      set(changeset, 'roleId', null);
      return changeset.save().then(() => {
        return this.loginAsDemoUser();
      });
    }
  },

  loginAsDemoUser() {
    return this.session
      .authenticate('authenticator:oauth2', 'demo@donorelf.com', 'password')
      .then(() => {
        return this.currentUser.load().then(() => {
          this.router.transitionTo('funds.fund', 'selected-fund');
        });
      });
  },

  error: action(function (error) {
    logger.error(`error logging in demo user: ${error}`);
    this.loginAsDemoUser();
    return false;
  }),
});
